export default __webpack_public_path__ + "static/media/6.402b7bd1.jpeg";